import { render } from "./UsuariosB2B.vue?vue&type=template&id=ee471438&scoped=true"
import script from "./UsuariosB2B.vue?vue&type=script&lang=js"
export * from "./UsuariosB2B.vue?vue&type=script&lang=js"

import "./UsuariosB2B.vue?vue&type=style&index=0&id=ee471438&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee471438"]])

export default __exports__